// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import { withRouter } from 'react-router-dom'
import StationPage from '../station/StationPage'
import ScoreCardThreshold from './ScoreCardThreshold'
import { Query } from 'react-apollo'
import { fetchChainScoreCardThresholds, fetchStationScoreCardThresholds } from './queries'
import Loader from '../../../common/loader/Loader'
import { RouteComponentProps } from 'react-router'

const Content = ({ station, chainMode }: { station?: any; chainMode?: boolean }) => (
  <div>
    <h2>{i18n.t('admin.scoreCardThresholds.heading')}</h2>
    <Query
      query={chainMode ? fetchChainScoreCardThresholds : fetchStationScoreCardThresholds}
      variables={{ stationId: station && station.id }}
      fetchPolicy={'network-only'}
    >
      {({ data: { chainScoreCardThresholds, stationScoreCardThresholds }, loading, error, refetch }) => (
        <Loader {...{ loading, error }}>
          <ScoreCardThreshold
            stationId={station && station.id}
            data={chainMode ? chainScoreCardThresholds : stationScoreCardThresholds}
            refetch={refetch}
          />
        </Loader>
      )}
    </Query>
  </div>
)

class ScoreCardThresholdsPage extends React.Component<RouteComponentProps & { chainMode?: boolean }> {
  render(): any {
    return !this.props.chainMode ? (
      <StationPage title={i18n.t('admin.stations.title.ScoreCardThresholdsPage')}>
        {({ station }) => <Content station={station} chainMode={this.props.chainMode} />}
      </StationPage>
    ) : (
      <Content chainMode={this.props.chainMode} />
    )
  }
}

export default withRouter(ScoreCardThresholdsPage)
